export enum SortFilter {
  menorPrecio = 'Menor precio',
  mayorPrecio = 'Mayor precio',
  masRecientes = 'Más recientes',
  masAntiguas = 'Más antiguas',
}
